var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFioul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0769 14.0929C44.0769 14.0929 44.2104 13.9986 44.4813 13.8141C45.6632 12.9973 46.5231 12.3887 46.7391 12.2395C48.5061 11.0066 51.1211 9.18074 54.5255 6.80518C77.59 41.2685 84.6971 72.4846 75.8702 81.5079C66.7449 90.8334 56.3906 91.2025 56.3906 91.2025C54.0268 91.2025 52.142 91.0062 51.1211 90.8413C45.0232 89.8557 36.0039 86.3925 33.1807 81.2173C26.4742 68.9272 56.4416 50.1229 50.1748 31.5857C48.7456 27.3646 42.7026 15.0627 44.073 14.0968L44.0769 14.0929Z",
    fill: "#FECECA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0767 14.0929C25.0722 33.5058 -1.89932 77.0905 44.0767 89.8361C85.4586 101.31 63.0812 45.1794 44.0767 14.0929Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFioul);
export default __webpack_public_path__ + "static/media/fioul.dc3fe350cbc0da47378a1f73e2eb8175.svg";
export { ForwardRef as ReactComponent };